// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/6/11
// +-------------------------------------------------------------
// |Time: 17:54
// +-------------------------------------------------------------
export default [
    {
        path: '/user-manage/user-list',
        name: "UserList",
        meta: {
            title: "用户列表"
        },
        component: () => import("@/views/User/User/Index")
    },
]